var React = require('react');

function UspArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M58.5246 0L48.2828 11.1643L89.25 55.8216H0V71.7707H89.25L48.2828 116.428L58.5246 127.592L117.049 63.7961L58.5246 0Z"}));
}

UspArrow.defaultProps = {"width":"118","height":"128","viewBox":"0 0 118 128","fill":"none"};

module.exports = UspArrow;

UspArrow.default = UspArrow;
